
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { CTASection } from "@/sections/CTASection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { CustomersLogosSection } from "@/sections/CustomersLogosSection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";
import { ConversionSection } from "@/sections/ConversionSection";
import { PricingSection } from "@/sections/PricingSection";

const EpsToFigma = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/EPSToFigma"
        ogImage="/images/eps2figma-og-image.jpg"
      />

      <MagicianSection
        title={t("page/EPSToFigma:title")}
        subtitle={t("page/EPSToFigma:subtitle")}
        magicianLogoFile="eps"
        cta={{
          title: t("section/magicians:seeHowItWorks"),
          scrollToId: "ApiTeaserSection",
        }}
      >
        {/* TODO: Enable this converter again after fixing https://magicul.atlassian.net/browse/MAG-3788 */}
        <Converter disabled />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/EPSToFigma:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/eps-to-figma-example.png",
          alt: "EPS to Figma converter example",
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        elements={t(
          "page/EPSToFigma:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/EPSToFigma:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/import-pdf-into-figma.jpg",
          alt: t("page/EPSToFigma:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/EPSToFigma:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "SPREAD-ICON",
            title: t(
              "page/EPSToFigma:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/EPSToFigma:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "FOLDER-SIMPLE-ICON",
            title: t(
              "page/EPSToFigma:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/EPSToFigma:section/shareDesign.elements.folderStructureText",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "CHECK-GREEN-ICON",
            title: t(
              "page/EPSToFigma:section/shareDesign.elements.imageSupportTitle",
            ),
            text: t(
              "page/EPSToFigma:section/shareDesign.elements.imageSupportText",
            ),
          },
        ]}
      />

      <PricingSection />

      <ConversionSection
        title={t("section/conversion:title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("section/conversion:badges.supportsAll"),
          },
          { iconType: "TV", text: t("section/conversion:badges.accuracy") },
        ]}
        elements={{
          from: {
            iconType: "EPS_FILE",
            image: "/images/pdf-example.png",
            title: "EPS Demo Preview",
          },
          to: {
            iconType: "FIGMA",
            image: "/images/figma-illustrator-preview.jpg",
            title: "Figma EPS Import Demo Preview",
          },
        }}
      />
      <CustomersLogosSection />

      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection
        title={t("section/cta:titles.epsToFigmaPage")}
        href="#upload"
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default EpsToFigma;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/eps-to-figma',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  